import { render } from "./AppUnauthorized.vue?vue&type=template&id=7637cb3c"
const script = {}

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__